import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class DeliveryNoteService extends GenericService {
    constructor() {
        super('/delivery_notes', axiosInstance);
    }

    async getDeliveredNotes(lpoNumber) {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/delivered_notes`, {
                params: { number: lpoNumber }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getOneGrouped(id) {
        try {
            const encodedId = this.encodePathSegment(id);
            const response = await axiosInstance.get(`${this.baseUrl}/${encodedId}/grouped`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new DeliveryNoteService(); 